<template>
	<div>
		<el-dialog :visible.sync="showMember" width="889px" :close-on-click-modal='false' :show-close="true"
			:close-on-press-escape='false'>
			<div class="member">
				<div class="headTop flex flex-b">
					<div>
						<div class="tit">会员中心</div>
						<div class="current">当前会员等级：{{loginUser.member.name}}</div>
					</div>
					<div class="record pointer" @click="openRecord=true">开通记录</div>
				</div>
				<div class="flex-only flex-b" style="margin: 10px 0;padding: 20px 30px;">
					<div class="left">
						<div class="flex flex-c-c" v-for="(item,index) in vipList" v-if="vipIndex==index">
							<img class="pointer" @click="vipIndexClick(-1)" src="@/assets/images/mine/ileft.png"
								style="width: 33px;height: 33px;" alt="" />
							<div class="vipBg">
								<img :src="item.level==1?require('@/assets/images/mine/vipBg1.png'):item.bg_img"
									style="width: 366px;height: 120px;margin: 0 30px;" alt="" />
								<div class="vipInfo">
									<div class="tx1" :style="{'color':item.text_color}">{{item.name}}</div>
									<!-- <div class="tx2">基础会员</div> -->
									<div class="tx3">当前可享 {{item.memberCount}} 项权益</div>
								</div>
							</div>
							<img class="pointer" @click="vipIndexClick(1)" src="@/assets/images/mine/iright.png"
								style="width: 33px;height: 33px;" alt="" />
						</div>
						<div class="flex flex-b" v-if="showIndex == index" v-for="(item,index) in vipBannerList">
							<div class="flex flex-c-c flex-column-item price" v-for="(bitm,bindex) in item"
								:class="vipIndex%3==bindex?'vipActive':''">
								<div class="tname">{{bitm.name}}</div>
								<div class="tprice"><span>¥{{bitm.price}}</span>/年</div>
							</div>
							<div style="min-width: 31%;" v-for="_item in 3-item.length%3"></div>
						</div>
						<div class="tip"><span>*</span>购买提示</div>
						<div class="tip1"
							v-if="vipIndex==index && vipList[vipIndex]&&vipList[vipIndex].name!='基础会员' && memberIndex==vipIndex"
							v-for="(item,index) in vipList">
							您当前为{{loginUser.member.name}}，续费{{vipList[vipIndex].name}}仅需{{vipList[vipIndex].price}}/年
						</div>
						<div class="tip1"
							v-if="vipIndex==index&&vipList[vipIndex]&&vipList[vipIndex].name!='基础会员' && memberIndex<vipIndex"
							v-for="(item,index) in vipList">
							您当前为{{loginUser.member.name}}，升级会员至{{vipList[vipIndex].name}}仅需{{vipList[vipIndex].price-loginUser.member.price}}/年
						</div>
						<div class="flex-only" style="margin-top: 20px;">
							<img class="pointer" src="@/assets/icon/xz.png" v-if="autoPay" @click="autoPay =!autoPay"
								style="width: 18px;height: 18px;" alt="" />
							<img class="pointer" src="@/assets/icon/wxz.png" v-else @click="autoPay=!autoPay"
								style="width: 18px;height: 18px;" alt="" />
							<div style="margin-left: 10px;">
								<div class="xf1">开启自动续费</div>
								<div class="xf2">自动续费将在会员到期时自动扣除积分进行续费</div>
							</div>
						</div>

						<div v-if="vipList[vipIndex]&&vipList[vipIndex].name!='基础会员' && memberIndex<vipIndex"
							class="login-btn pointer" @click="toPage(0,'/buyVip?id='+vipList[vipIndex].uuid)">
							<span class="text">立即升级</span>
						</div>
						<div v-if="vipList[vipIndex]&&vipList[vipIndex].name!='基础会员' && memberIndex==vipIndex"
							class="login-btn pointer" @click="toPage(0,'/buyVip?id='+vipList[vipIndex].uuid)">
							<span class="text">立即续费</span>
						</div>

					</div>
					<div class="right flex-1" style="margin-left: 30px;" v-if="vipList[vipIndex]">
						<div class="flex flex-c-c" style="margin-bottom: 10px;">
							<img src="@/assets/images/mine/vipt1.png" style="width: 136px;height: 23px;" alt="" />
						</div>
						<div class="tqbox  flex" :class="!item.showFlag?'gary':''"
							v-for="(item,index) in vipList[vipIndex].tqList">
							<img class="op" :src="item.icon" style="width: 49px;height: 49px;margin-right: 10px;"
								alt="" />
							<div class="op">
								<div class="rname">{{item.name}}</div>
								<div class="rdet">{{item.det}}</div>
							</div>
							<img class="lock" v-if="!item.showFlag" src="@/assets/images/mine/ilock.png"
								style="width: 27px;height: 27px;" alt="" />
						</div>
					</div>
				</div>
			</div>
		</el-dialog>


		<!-- 会员开通记录 -->
		<el-dialog :visible.sync="openRecord" width="500px" :close-on-click-modal='false' :show-close="true"
			:close-on-press-escape='false'>
			<div class="record">
				<div class="tit">会员开通记录</div>
				<div class="wbox2">
					<div class="item" v-for="(item,i) in memberLogList">
						<div class="flex flex-b">
							<div class="t2">{{item.content}}</div>
							<div class="t3">-{{item.pay_type==1?item.score:item.price}}</div>
						</div>
						<div class="flex flex-b">
							<div class="time">{{item.create_time}}</div>
							<div class="time">{{item.pay_type==1?'积分支付':'微信支付'}}</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getMember,
		getMemberList,
		getMemberOrderLog
	} from "@/api/common";
	import Utils from "@/jslibs/utils";
	export default {
		data() {
			return {
				openRecord: false, //开通记录
				showMember: false, //会员中心
				vipList: [], //vip类型列表
				// tqList: [{
				// 	icon: require('@/assets/images/mine/vpp1.png'),
				// 	name: '身份挂件',
				// 	det: '专属身份认证',
				// 	showFlag: false
				// }, {
				// 	icon: require('@/assets/images/mine/vpp2.png'),
				// 	name: '课程折扣',
				// 	det: '单章优惠200积分，整课优惠1000积分',
				// 	showFlag: false
				// }, {
				// 	icon: require('@/assets/images/mine/vpp3.png'),
				// 	name: '专属培训',
				// 	det: '会员专属技能培训',
				// 	showFlag: false
				// }, {
				// 	icon: require('@/assets/images/mine/vpp4.png'),
				// 	name: '加倍积分',
				// 	det: '付费会员享受加倍积分获取',
				// 	showFlag: false
				// }, {
				// 	icon: require('@/assets/images/mine/vpp5.png'),
				// 	name: '免费学课',
				// 	det: '平台课程全部免费学习',
				// 	showFlag: false
				// }], //特权列表
				vipIndex: 0,
				loginUser: {
					member: {}
				},
				autoPay: true,
				memberLogList: [],
				memberIndex: 0,
				vipBannerList: [],
				showIndex: 0
			}
		},
		mounted() {
			if (Utils.getCookie('loginUser')) {
				this.loginUser = JSON.parse(Utils.getCookie('loginUser'))
			}
			this.getMemberList()
			this.getMemberOrderLog()
		},
		methods: {
			async getMemberOrderLog() {
				const {
					status,
					data
				} = await getMemberOrderLog({});
				this.memberLogList = data.result
			},
			async getMemberList() {
				const {
					status,
					data
				} = await getMemberList({});
				this.vipList = data.result
				this.vipList.forEach(item => {
					let tqList = []
					let memberCount = 2
					tqList.push({
						icon: require('@/assets/images/mine/vpp1.png'),
						name: '身份挂件',
						det: '专属身份认证',
						showFlag: true
					})
					tqList.push({
						icon: require('@/assets/images/mine/vpp2.png'),
						name: '课程折扣',
						det: '单章优惠' + item.discount + '积分，整课优惠' + item.all_discount + '积分',
						showFlag: true,
					})
					tqList.push({
						icon: require('@/assets/images/mine/vpp3.png'),
						name: '专属培训',
						det: '会员专属技能培训',
						showFlag: false
					})
					if (item.doubled > 0) {
						tqList.push({
							icon: require('@/assets/images/mine/vpp4.png'),
							name: '加倍积分',
							det: '付费会员享受加倍积分获取',
							showFlag: true
						})
						memberCount += 1
					} else {
						tqList.push({
							icon: require('@/assets/images/mine/vpp4.png'),
							name: '加倍积分',
							det: '付费会员享受加倍积分获取',
							showFlag: false
						})
					}
					if (item.is_fee == 1) {
						tqList.push({
							icon: require('@/assets/images/mine/vpp5.png'),
							name: '免费学课',
							det: '平台课程全部免费学习',
							showFlag: true
						})
						memberCount += 1
					} else {
						tqList.push({
							icon: require('@/assets/images/mine/vpp5.png'),
							name: '免费学课',
							det: '平台课程全部免费学习',
							showFlag: false
						})
					}
					this.$set(item, 'tqList', tqList)
					this.$set(item, 'memberCount', memberCount)
					this.memberIndex = this.vipList.findIndex(item => {
						return item.uuid == this.loginUser.member.uuid
					})
				})
				var result = [];
				for (var i = 0; i < this.vipList.length; i += 3) {
					result.push(this.vipList.slice(i, i + 3));
				}
				this.vipBannerList = result
			},
			vipIndexClick(e) {
				if (this.vipIndex == 0 && e == -1) {
					this.vipIndex = this.vipList.length - 1
					this.showIndex = Math.floor(this.vipIndex / 3)
					return
				}
				if (this.vipIndex == this.vipList.length - 1 && e == 1) {
					this.vipIndex = 0
					this.showIndex = Math.floor(this.vipIndex / 3)
					return
				}
				this.vipIndex += e
				this.showIndex = Math.floor(this.vipIndex / 3)
			},
			toPage(index, url) {
				if (index == 1) {
					this.showMember = true
				} else if (index == 3) {
					this.showPoints = true
				} else if (index == 6) {
					this.editInfo = true
				} else {
					this.$router.push({
						path: url
					})
				}
			},
			openDialog() {
				this.showMember = true
			},
		}
	}
</script>

<style scoped lang="less">
	.login-btn {
		width: 550px;
		height: 46px;
		background: url('../assets/images/login/loginbtn.png') no-repeat;
		background-size: 100% 100%;
		margin-top: 13px;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	/deep/ .el-dialog__header {
		padding: 0 !important;
	}

	/deep/ .el-dialog__body {
		padding: 0 !important;
	}

	::v-deep .el-dialog__close:hover {
		color: #999;
	}

	::v-deep .el-dialog__headerbtn {
		font-size: 24px;
	}

	.record {
		padding-bottom: 30px;

		.tit {
			padding: 20px 0;
			text-align: center;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 20px;
			color: #000000;
		}

		.wbox2 {
			height: 400px;
			overflow-y: scroll;
			padding: 0 20px;

			.item {
				padding: 10px 0;
				border-bottom: 1px solid #EEEEEE;

				&:last-child {
					border-bottom: none;
				}

				.t1 {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 18px;
					color: #000000;
				}

				.jf {
					margin-top: 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #000000;

					span {
						margin-left: 4px;
						color: #00A73C;
					}
				}

				.status {
					height: 36px;
					line-height: 36px;
					background: linear-gradient(136deg, #7FDA4C 0%, #10B649 100%);
					border-radius: 11px 11px 11px 11px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					color: #FFFFFF;
					padding: 0 16px;

					&.status1 {
						background: #CCCCCC;
					}
				}

				.t2 {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}

				.t3 {
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 18px;
					color: #333333;
				}

				.time {
					margin-top: 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
				}
			}
		}
	}

	.member {
		.headTop {
			border-radius: 18px 18px 0 0;
			background: #FCF8ED;
			padding: 16px 80px 16px 20px;

			.tit {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 20px;
				color: #000000;
			}

			.current {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #C99922;
			}

			.record {
				height: 36px;
				line-height: 36px;
				padding: 0 10px;
				background: #FFFFFF;
				border-radius: 27px 27px 27px 27px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 14px;
				color: #666666;
			}
		}

		.left {
			width: 65%;

			.vipBg {
				position: relative;

				.vipInfo {
					position: absolute;
					left: 50px;
					top: 20px;

					.tx1 {
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 600;
						font-size: 24px;
						color: #333333;
					}

					.tx2 {
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 16px;
						color: #666666;
					}

					.tx3 {
						margin-top: 10px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #C99922;
					}
				}
			}

			.price {
				margin: 20px 7px;
				min-width: 31%;
				height: 164px;
				background: #F7F8F9;
				border-radius: 13px 13px 13px 13px;
				flex-shrink: 0;
				scroll-snap-align: start;

				.tname {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 18px;
					color: #333333;
				}

				.tprice {
					margin-top: 10px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #00A73C;

					span {
						font-family: DINPro, DINPro;
						font-weight: bold;
						font-size: 22px;
						color: #00A73C;
					}
				}
			}

			.vipActive {
				background: rgba(234, 207, 140, 0.07);
				border: 1px solid #D7B155;
			}

			.tip {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;

				span {
					margin-right: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FC5F5F;
				}
			}

			.tip1 {
				margin-top: 4px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #000000;
			}

			.xf1 {
				line-height: 18px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
			}

			.xf2 {
				margin-top: 4px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}

		}

		.tqbox {
			margin: 10px 0;
			width: 100%;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 14px 20px;

			.rname {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}

			.rdet {
				margin-top: 4px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}

			.lock {
				position: absolute;
				z-index: 999;
				content: '';
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
				opacity: 0;
			}
		}

		.gary {
			filter: grayscale(100%);
			position: relative;

			.op {
				opacity: 0.3;
			}

			.lock {
				opacity: 1;
			}
		}
	}
</style>